module.exports = __webpack_public_path__ + "img/code3.af706e43.png";